import type { ReactElement } from "react";

/**
 * Curved office-caption mark. Local SVG space points up-right.
 */
export function FunnelCurveArrow({
  className,
}: {
  readonly className: string;
}): ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 140 160"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M38 150Q32 88 107 50"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <path
        d="M100 28 128 40 114 72"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
